import { render } from "./HomeLayout.vue?vue&type=template&id=20d43a7f"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"

import "./HomeLayout.vue?vue&type=style&index=0&id=20d43a7f&lang=css"

import exportComponent from "/usr/local/src/public-poll/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__